export const setScreenNumber = (screenNumber) =>
	({
		type    : 'SET_SCREEN_NUMBER',
		payload : { screenNumber }
	});
export const setScreenLimit = (screenLimit) =>
	({
		type    : 'SET_SCREEN_LIMIT',
		payload : { screenLimit }
	});
export const setScreenPeers = (screenPeers) =>
	({
		type    : 'SCREEN_PEERS',
		payload : { screenPeers }
	});
export const addScreenPeer = (screenPeer) =>
	({
		type    : 'ADD_SCREEN_PEER',
		payload : { screenPeer }
	});
export const removeScreenPeer = (peerId) =>
	({
		type    : 'REMOVE_SCREEN_PEER',
		payload : { peerId }
	});

export const addCrashPeers = (crashPeers) =>
	({
		type    : 'ADD_CRASH_PEERS',
		payload : { crashPeers }
	});

export const clearScreen = () =>
	({
		type : 'clear_screen'
	});